/**
 * Learning Type model
 */
export class LearningType {
  constructor(public value: string, public tooltip: string, public menuDescription?: string) {}
}
